<button
  class="button is-small"
  [class.is-active]="isActive"
  [attr.data-theme]="theme()"
  [cdkMenuTriggerFor]="menu"
  (cdkMenuOpened)="isActive = true"
  (cdkMenuClosed)="isActive = false">
  <topo-icon [props]="menuTriggerIconProps" />
</button>

<ng-template #menu>
  <div
    cdkMenu
    class="action-menu"
    [style.min-width.px]="300"
    [style.zIndex]="1002">
    @for (section of menuSections(); track section.id) {
      @if (section.id === 'horizon_sso') {
        <ng-container *ngTemplateOutlet="horizonMenuItem" />
      } @else {
        <div class="menu-section">
          @if (!!section.title) {
            <label>{{ section.title | translate }}</label>
          }

          @for (item of section.items; track item.id) {
            <a
              cdkMenuItem
              class="action-menu-item"
              [routerLink]="item.route">
              <topo-icon [props]="item.iconProps" />
              <span>{{ item.label | translate }}</span>
            </a>
          }
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #horizonMenuItem>
  <div class="menu-section">
    <div
      class="action-menu-item"
      (click)="generateHorizonRedirect()">
      @let c24Logo = isDarkMode() ? 'crisis24-logo-reverse' : 'crisis24-logo';
      <img
        class="c24-logo-img"
        style="height: 2.5rem; width: 2.5rem"
        [attr.src]="'/assets/images/' + c24Logo + '.svg'" />
      <span>{{ 'MANAGEMENT.MENU.HORIZON' | translate }}</span>
      <div
        class="external-link"
        style="flex: 1; display: flex; justify-content: flex-end; align-items: center">
        <i class="icon icon-new_window"></i>
      </div>
    </div>
  </div>
</ng-template>
